import ServiceDetail from "@/components/ServiceDetail";
import { SERVICES_DATA } from "@/data/services";
import { GALLERY_ITEMS } from "@/data/gallery";

export default function Concrete() {
    const projects = GALLERY_ITEMS.filter((g) => g.category === "concrete");
    return <ServiceDetail data={SERVICES_DATA.concrete} projects={projects} />;
}
